import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import { toast } from "react-toastify";
import intl from "../../i18n/intl";

const initialState = {
  data: [],
  record: null,
  requesting: false,
  error: null,
  action: null,
  query: {
    pageNo: 1,
    pageSize: 50,
    sortBy: "asc",
    sortColumn: "name",
    namePattern: "",
  },
};

const customIntl = intl();

const enterprisesSlice = createSlice({
  name: "enterprises",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    listRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
      state.record = null;
    },
    listSuccess: (state, action) => {
      state.data = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    listFail: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    createRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "create";
    },
    createSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage({ id: "enterprise_create_success" })
      );
    },
    createFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    enterpriseDetailsRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "enterprise_details";
      state.record = null;
    },
    enterpriseDetailsSuccess: (state, action) => {
      state.record = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    enterpriseDetailsFail: (state, action) => {
      state.record = null;
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    updateSelfEnterpriseDetailRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "update";
    },
    updateSelfEnterpriseDetailSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "enterprise" }),
          }
        )
      );
    },
    updateSelfEnterpriseDetailFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    setQuery: (state, action) => {
      state.query = {
        ...state.query,
        ...action.payload,
      };
    },
  },
});

export const {
  createFail,
  createRequest,
  createSuccess,
  listFail,
  listRequest,
  listSuccess,
  setQuery,
  enterpriseDetailsFail,
  enterpriseDetailsRequest,
  enterpriseDetailsSuccess,
  updateEnterpriseDetailFail,
  updateEnterpriseDetailRequest,
  updateEnterpriseDetailSuccess,
} = enterprisesSlice.actions;
export default enterprisesSlice.reducer;
